import api from './api.service';

export interface Customer {
  id: string;
  company_id: string;
  customer_code: string;
  customer_name: string;
  customer_type: string;
  industry?: string;
  contact_person?: string;
  email?: string;
  phone?: string;
  mobile?: string;
  website?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  /** Present when this customer is the primary Education fee payer for a student. */
  student_id?: string;
  student_admission_no?: string | null;
  student_name?: string | null;
  is_education_student_customer?: boolean;
}

class CustomerService {
  /**
   * Get all customers
   */
  async getAllCustomers(params?: {
    search?: string;
    is_active?: boolean;
    page?: number;
    limit?: number;
  }): Promise<{ data: Customer[] }> {
    const response = await api.get('/sales/customers', { params });
    return response.data;
  }

  /**
   * Get customer by ID
   */
  async getCustomerById(id: string): Promise<{ data: Customer }> {
    const response = await api.get(`/sales/customers/${id}`);
    return response.data;
  }

  /**
   * Get active customers (for dropdowns)
   */
  async getActiveCustomers(): Promise<Customer[]> {
    try {
      const response = await api.get('/sales/customers/list', {
        params: { is_active: true, limit: 1000 }
      });
      
      console.log('✅ [CustomerService] getActiveCustomers response:', response);
      console.log('✅ [CustomerService] response.data:', response.data);
      console.log('✅ [CustomerService] response.data type:', typeof response.data);
      console.log('✅ [CustomerService] response.data is array:', Array.isArray(response.data));
      
      // Handle different response structures
      let customers: Customer[] = [];

      // api.service already returns response.data body, but keep fallback branches
      if (Array.isArray(response)) {
        customers = response;
      } else if (Array.isArray(response.data)) {
        customers = response.data;
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        customers = response.data.data;
      } else if (response.data?.success && Array.isArray(response.data.data)) {
        customers = response.data.data;
      } else if (response.data?.customers && Array.isArray(response.data.customers)) {
        customers = response.data.customers;
      } else if (Array.isArray((response as any)?.customers)) {
        customers = (response as any).customers;
      } else if (Array.isArray((response as any)?.data)) {
        customers = (response as any).data;
      }
      
      console.log('✅ Loaded customers:', customers.length);
      if (customers.length > 0) {
        console.log('✅ Sample customer:', customers[0]);
      } else {
        console.warn('⚠️ No customers found in response');
      }
      
      return customers;
    } catch (error: any) {
      console.error('❌ Error fetching active customers:', error);
      console.error('❌ Error response:', error.response?.data);
      return [];
    }
  }
}

export default new CustomerService();

